import Node from '../node.js';
import { PARAM_TYPE, PARAM_UNITS } from '../connector.js';
import Spline from '../spline.js';

export default class NodeCreateRectangle extends Node
{
	constructor(pParent)
	{
		super(pParent);

		this.addInput(PARAM_TYPE.FLOAT, 'width', 1, { units: PARAM_UNITS.METERS });
		this.addInput(PARAM_TYPE.FLOAT, 'height', 1, { units: PARAM_UNITS.METERS });

		this.addInput(PARAM_TYPE.BOOLEAN, 'closed', true);
		this.addInput(PARAM_TYPE.BOOLEAN, 'top_only', false);

		this.addInput(PARAM_TYPE.FLOAT, 'corner_radius', 0.0, { minValue: 0, maxValue: 0.5, units: PARAM_UNITS.METERS });
		this.addInput(PARAM_TYPE.FLOAT, 'roughness', 0.0025, { minValue: 0.001, maxValue: 0.2 });

		this.addOutput(PARAM_TYPE.SPLINE, 'geo');	
	}

	getType()
	{
		return 'createRectangle';
	}

	generateSubclass(scene, inputValues, outputName, computedOutputResults)
	{
		return  Spline.createRectangle(inputValues['width'], inputValues['height'], inputValues['closed'], inputValues['corner_radius'], inputValues['roughness'], inputValues['top_only']);
	}
}